<template>
  <div class="table-list">
    <div class="table-box" v-for="(table, i) in service.tables" :key="'group' + i">
      <div class="title">{{ table.title }}</div>
      <SimpleTable :service="table" :types="types" />
    </div>
  </div>
</template>

<script>
import SimpleTable from "../table/SimpleTable";

export default {
  components: { SimpleTable },
  props: {
    service: Object,
    types:String
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 0.28rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  margin-bottom: 0.2rem;
}
.table-box {
  margin: 0.1rem 0;
  background: #f6f6f6;
}
.table-list {
  font-size: 0.24rem;
  padding: 0 0.24rem;
}
</style>
